import {
    useAppContainerStyle,
    useConfig,
    useFirebaseAnalytics,
} from '@/shared/hooks'
import { useAppStore } from '@/shared/store'
import { useEffect, useState } from 'react'
import { refreshAccessToken } from '@/api/apiClient'
import { refreshInterval } from '@/shared/constants'
import {
    getFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import useFavoritesChannels from '@/features/favorites/useFavoritesChannels'

export const useApp = () => {
    const appContainerStyle = useAppContainerStyle()
    const token: string | null = getFromLocalStorage(sessionTokenLsKeyword)

    const [isAppReady, setIsAppReady] = useState(false)
    const [isTokenInStorage, setIsTokenInStorage] = useState(!!token)
    const { isUserLoggedIn, isGuest, actualProfile } = useAppStore()
    const { takeConfigIfNeed } = useConfig()
    const { getFavoritesChannels } = useFavoritesChannels()

    const authenticateAndFetchConfig = async () => {
        if (!isTokenInStorage) {
            const token = getFromLocalStorage(sessionTokenLsKeyword)
            if (token) {
                setIsTokenInStorage(true)
            }
        }
        await takeConfigIfNeed()
        setIsAppReady(true)
    }

    const { analyticsLogEvent } = useFirebaseAnalytics()

    analyticsLogEvent('start_app')

    const analyticsMethods = {
        analyticsLogEvent,
    }

    const refreshTokenAndData = async () => {
        const newToken = await refreshAccessToken()
        if (newToken) {
            getFavoritesChannels()
        }
    }

    useEffect(() => {
        const interval = setInterval(() => {
            refreshTokenAndData
        }, refreshInterval)

        authenticateAndFetchConfig()
        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        if (!token) refreshTokenAndData()
    }, [token])

    useEffect(() => {
        if (actualProfile?.id) {
            getFavoritesChannels()
        }
    }, [actualProfile?.id])

    return {
        appContainerStyle,
        isAppReady,
        isUserLoggedIn,
        isGuest,
        analyticsMethods,
        analyticsLogEvent,
    }
}
